import * as ActionTypes from './actionTypes.js';
import extend from 'lodash/extend'

export default function commissionSummaryReducer(state = {}, action) {
    switch (action.type) {
        case ActionTypes.MODAL_VISIBILITY:
            return extend({}, state, action.payload);
        case ActionTypes.AGENT_MODAL_VISIBILITY:
            return extend({}, state, action.payload);
        case ActionTypes.DATE_MODAL_VISIBILITY:
            return extend({},state,action.payload);
        case ActionTypes.TRANSFER_MODAL_VISIBILITY:
            return extend({},state,action.payload); 

        default:
            return state;
    }
}
